import React from 'react';
import { CrmMergeLeadsOperation } from '../../hooks/services';
import './LendingSupport.scss';

interface MergeLeadsOperationsProps {
  operations: CrmMergeLeadsOperation[];
}

/**
 * This component renders the CRM merge leads operations section of the lending
 * support tool, showing each CRM lead search recorded for the deal with its
 * outcome and reasons.
 */
export const MergeLeadsOperations: React.FC<MergeLeadsOperationsProps> = ({
  operations,
}) => {
  if (!operations.length) {
    return <div>n/a</div>;
  }

  return (
    <table className="lending-support-merge-operations-table">
      <thead>
        <tr>
          <th>Created At</th>
          <th>Outcome</th>
          <th>Matched Visit ID</th>
          <th>Reasons</th>
          <th>CRM</th>
        </tr>
      </thead>
      <tbody>
        {operations.map((operation) => (
          <tr key={operation.id}>
            <td>{new Date(operation.createdAt).toLocaleString()}</td>
            <td>{operation.outcome}</td>
            <td>{operation.matchedVisitId ?? 'n/a'}</td>
            <td>{operation.reasons.join(', ')}</td>
            <td>{operation.crmType}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
